import modelsResolver from 'utils/api/models/utils/modelsResolver';
import { CommitmentDetails } from 'utils/api/models/payments/commitmentDetails';

export type CommitmentDetailsResponse = {
	_details: any;
	details: CommitmentDetails[];
};

const model: types.models.InputModel = {
	_details: 'response.getCommitmentDetailsResponse.details',
	details: (model: CommitmentDetailsResponse) =>
		model._details.map((singleDetails: any) => modelsResolver(singleDetails, 'commitmentDetails')),
};

export default model;
